module.exports = __webpack_public_path__ + "img/bell-red.effcd31.svg";